// extracted by mini-css-extract-plugin
export default {"mobileWrapper":"A8gAuS0CBniNATmmhfGf"};